import { init, Selectors } from '@makemydeal/dr-activities-role-assumption';
import { APP_NAME } from './constants';
import { hostActions } from './hostActions';
import { additionalSelectors } from './additionalSelectors';

let roleAssumptionSelectors: Selectors;

export const configureRoleAssumption = () => {
    const { middlewareMgr, selectors } = init(APP_NAME, additionalSelectors, hostActions);
    roleAssumptionSelectors = selectors;
    return middlewareMgr;
};

export const getRoleAssumptionSelectors = (): Selectors => roleAssumptionSelectors;
